{
  "intro": "古物の受入・払出（買取・委託・返品）をすべて記録します。3年以上保存します。",
  "readonly": "古物台帳は変更・削除できません（古物営業法）。誤りは訂正の行を追加して直します。",
  "not_checked": "様式15・様式16のレイアウトは、まだ行政書士の確認を受けていません。",
  "tabs": {
    "label": "表示",
    "all": "すべて",
    "incomplete": "不足あり"
  },
  "columns": {
    "date": "取引日",
    "type": "受入・払出",
    "item": "品目・特徴",
    "quantity": "数量",
    "price": "代価",
    "counterparty": "相手方",
    "address": "住所",
    "occupation": "職業",
    "age": "年齢",
    "minor": "18歳未満",
    "method": "確認方法",
    "no_method": "本人確認なし",
    "channel": "方法",
    "tax": "税の扱い",
    "source": "区分",
    "reference": "参照",
    "staff": "記録者",
    "correction": "訂正の行"
  },
  "entry_type": {
    "receive": "受入",
    "deliver": "払出"
  },
  "counterparty": {
    "individual": "個人",
    "business": "事業者"
  },
  "channel": {
    "face_to_face": "対面",
    "remote": "非対面"
  },
  "tax": {
    "kobutsu_tokurei": "古物商特例",
    "shogaku_tokurei": "少額特例",
    "transitional_70": "経過措置 80/70 %",
    "qualified_invoice": "適格請求書",
    "not_applicable": "仕入ではない"
  },
  "source": {
    "buylist": "買取",
    "consignment": "委託",
    "customer_return": "お客様の返品"
  },
  "filters": {
    "date": "日付（日本時間）",
    "counterparty": "相手方の名前",
    "q": "カード・番号・鑑定番号",
    "q_hint": "例：095/069 や 12345678",
    "big": "1万円以上"
  },
  "incomplete": {
    "banner_one": "本人確認または必須項目が足りない行が{{count}}件あります。",
    "banner_other": "本人確認または必須項目が足りない行が{{count}}件あります。",
    "show": "表示する",
    "fix": "本人確認がまだの委託者",
    "missing": "足りないもの",
    "none": "すべての行がそろっています。"
  },
  "problems": {
    "identity_check_missing": "本人確認なし",
    "counterparty_address_missing": "住所なし",
    "counterparty_occupation_missing": "職業なし",
    "counterparty_age_missing": "年齢なし",
    "confirmation_method_missing": "確認方法なし",
    "item_features_missing": "特徴なし"
  },
  "entry": {
    "title": "古物台帳の行",
    "load_failed": "この行を読み込めませんでした。",
    "date": "取引日時",
    "item": "品目",
    "features": "特徴",
    "category": "区分",
    "quantity": "数量",
    "price": "代価",
    "total": "取引の総額",
    "counterparty": "相手方",
    "address": "住所",
    "occupation": "職業",
    "age": "年齢",
    "method": "確認方法",
    "channel": "方法",
    "tax": "税の扱い",
    "source": "区分",
    "kept_until": "保存期限",
    "corrected_one": "{{count}}回訂正あり",
    "corrected_other": "{{count}}回訂正あり",
    "corrections": "訂正"
  },
  "correction": {
    "button": "訂正の行を追加",
    "title": "訂正の行を追加",
    "intro": "元の行はそのまま残し、正しい値と理由を書いた新しい行を追加します。",
    "field": "誤っていた項目",
    "value": "正しい値",
    "reason": "理由",
    "save": "訂正を追加",
    "missing": "正しい値と理由を入れてください。",
    "done": "訂正の行を追加しました。",
    "fields": {
      "itemDescription": "品目",
      "itemFeatures": "特徴",
      "counterpartyName": "氏名",
      "counterpartyAddress": "住所",
      "counterpartyOccupation": "職業",
      "confirmationMethod": "確認方法"
    }
  },
  "export": {
    "button": "出力",
    "title": "古物台帳を出力",
    "intro": "警察用（様式15・様式16）またはExcel用（CSV）。",
    "format": "種類",
    "formats": {
      "style15": "様式15・受入",
      "style15_hint": "受入のPDF",
      "style16": "様式16・払出",
      "style16_hint": "払出のPDF",
      "csv": "CSV",
      "csv_hint": "全行・Excelで開けます"
    },
    "range": "期間",
    "presets": {
      "last_month": "先月",
      "this_month": "今月",
      "custom": "日付を選ぶ"
    },
    "from": "開始",
    "to": "終了",
    "bad_range": "開始日が終了日より後です。",
    "audited": "出力はすべて記録されます（誰が・いつ）。",
    "not_checked": "レイアウトはまだ行政書士の確認を受けていません。",
    "make_pdf": "PDFを作る",
    "download_csv": "CSVをダウンロード",
    "making": "PDFを作成中…",
    "open_one": "PDFを開く（{{count}}行）",
    "open_other": "PDFを開く（{{count}}行）",
    "failed": "PDFを作れませんでした。"
  }
}
